import { Tag } from '@dnb/eufemia';
import { useSearchParams } from 'react-router-dom';

import { useEventFilterParams } from '@/hooks/useEventFilterParams';

export function EventFilterTags() {
  const [, setSearchParams] = useSearchParams();
  const filterParams = useEventFilterParams();

  function removeFilterValue(filterKey: string, value: string) {
    setSearchParams((prev) => {
      const values = prev.getAll(filterKey);
      const updatedValues = values.filter((v) => v !== value);

      prev.delete(filterKey);
      updatedValues.forEach((v) => prev.append(filterKey, v));

      prev.delete('page'); // Reset page index on filter change
      return prev;
    });
  }

  return (
    <div>
      <Tag.Group label="Filters" top="x-small">
        {filterParams.stage?.map((stage) => (
          <Tag key={stage} onClick={() => removeFilterValue('stage', stage)} variant="removable">
            {stage}
          </Tag>
        ))}
        {filterParams.classification?.map((classification) => (
          <Tag
            key={classification}
            onClick={() => removeFilterValue('classification', classification)}
            variant="removable"
          >
            {classification}
          </Tag>
        ))}
        {filterParams.serviceDomainId?.map((serviceDomainId) => (
          <Tag
            key={serviceDomainId}
            onClick={() => removeFilterValue('serviceDomainId', serviceDomainId)}
            variant="removable"
          >
            {serviceDomainId}
          </Tag>
        ))}
      </Tag.Group>
    </div>
  );
}
